export default __webpack_public_path__ + "static/media/P350MANB2.645fc6de.pdf";